export class UserListModel {
  usrId?: number;
  usrEmailId?: string = '';
  usrRole?: string = '';
  userDisplyName?: string = '';
  phoneNbr?: string = '';
  lastLoginDate?: string & Date | undefined = undefined;
}
